<template>
  <div class="page">
    <!-- 筛选 -->
    <div class="filter">
      <el-input
        placeholder="请输入内容"
        v-model="keyword"
        clearable
        prefix-icon="el-icon-search"
        class="sousuo"
        size="small"
      >
      </el-input>
      <el-button type="warning" @click="getTableData" size="small"
        >搜索</el-button
      >
      <div class="filterName">种类：</div>
      <el-select
        v-model="applyType"
        placeholder="请选择"
        class="titleSelect"
        style="width: 88px"
        size="small"
        @change="getTableData"
      >
        <el-option
          v-for="item in applyTypes"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <div class="filterName" v-if="shopType == 0">门店：</div>
      <el-select
        v-model="shopId"
        placeholder="请选择"
        class="titleSelect"
        style="width: 100px"
        size="small"
        @change="getTableData"
        v-if="shopType == 0"
      >
        <el-option
          v-for="item in shops"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-button
        type="warning"
        plain
        size="small"
        style="margin: 0 10px"
        @click="resetClick"
        >重置</el-button
      >
      <div class="filterR">
        <el-button
          type="warning"
          plain
          size="small"
          @click="handelAllClick"
          v-show="!$public.getShopStore(shopId)"
          >全选</el-button
        >
        <el-button
          type="warning"
          size="small"
          style="margin-right: 16px"
          @click="handelPetReceiveClick"
          >宠物接收
        </el-button>
      </div>
    </div>
    <div class="view">
      <div
        class="item"
        v-for="(item, index) in tableData"
        :key="index"
        @click="item.isClick = !item.isClick"
        :style="{ background: item.isClick ? 'rgba(0, 0, 0, 0.29)' : '#fff' }"
      >
        <div class="itemL">
          <div class="itemName">{{ item.petName }}</div>
          <div class="itemMsg">
            <div>
              {{ item.categoryInfo == null ? "--" : item.categoryInfo.name }}
            </div>
            <div class="shu"></div>
            <div>{{ item.petSex == null ? "--" : item.petSex }}</div>
            <div class="shu"></div>
            <div>{{ item.age }}</div>
          </div>
          <div class="epromNo">
            芯片:{{ item.epromNo == null ? "--" : item.epromNo }}
          </div>
          <div class="insideNo">
            脖圈:{{ item.insideNo == null ? "--" : item.insideNo }}
          </div>
        </div>
        <el-image class="itemR" :src="item.cover" fit="fill"></el-image>
        <img
          src="../../../assets/img/ht_dui.png"
          class="dui"
          v-if="item.isClick"
        />
      </div>
      <div v-if="petCageState">
        <drawerPetCage
          :petId="petId"
          :petCage="petCage"
          :receiveShopId="receiveShopId"
          @submit="submit_drawerStatus"
        ></drawerPetCage>
      </div>
    </div>
  </div>
</template>

<script>
import { waitReceive, petReceive } from "@/api/purchaseApi.js";
import drawerPetCage from "../../../components/drawerPetCage/drawer_petCage.vue";
export default {
  components: {
    drawerPetCage,
  },
  props: {
    shopType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      petId: "",
      receiveShopId: "",
      petCage: "",
      // 宠物笼子
      petCageState: false,
      tableData: [],
      applyType: "", //分类数据
      applyTypes: [
        {
          value: "1",
          label: "猫类",
        },
        {
          value: "2",
          label: "犬类",
        },
      ],
      keyword: "", //列表搜索内容
      shops: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "5e9412e0b2bfbc089daerr12",
          label: "金水区店",
        },
        {
          value: "5e9412e0b2bfbc089daerr14",
          label: "指挥中心",
        },
        {
          value: "5e9412e0b2bfbc089daerr18",
          label: "郑东新区店",
        },
        {
          value: "5e9412e0b2bfbc089daerr10",
          label: "驯养中心",
        },
      ],
      shopId: this.$store.state.shopId, //门店id
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    submit_drawerStatus() {
      this.petCageState = false;
      this.getTableData();
    },
    formatChu(a) {
      if (a < 12) {
        return a + "个月";
      }
      if (a == 12) {
        return "1岁";
      } else {
        var n1 = Math.floor(a / 12);
        var n2 = a % 12;
        console.log(a, n1, n2);
        return n1 + "岁" + n2 + "个月";
      }
    },
    // 重置
    resetPet() {
      for (let i = 0; i < this.tableData.length; i++) {
        this.tableData[i].isClick = false;
      }
    },
    //宠物接收
    handelPetReceiveClick() {
      if (this.$public.getShopStore(this.receiveShopId)) {
        let arr = [];
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].isClick) {
            arr.push(this.tableData[i].petId);
          }
        }
        if (!arr.length) {
          this.$message({
            type: "error",
            message: "请选择要接收的宠物",
          });
          return;
        }
        if (arr.length > 1) {
          this.$message({
            type: "error",
            message: "每次接收一只宠物",
          });
          arr = [];
          this.resetPet();
          return;
        }
        this.petId = arr[0];
        this.petCage = "add";
        this.petCageState = true;
      } else {
        this.$confirm("是否接收宠物？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let arr = [];
            for (let i = 0; i < this.tableData.length; i++) {
              if (this.tableData[i].isClick) {
                arr.push(this.tableData[i].petId);
              }
            }
            if (!arr.length) {
              this.$message({
                type: "error",
                message: "请选择要接收的宠物",
              });
              return;
            } else {
              let params = {
                id: arr,
              };
              petReceive(params).then((res) => {
                if (res.code == 0) {
                  console.log("已接收");
                  this.$message({
                    type: "success",
                    message: "已接收",
                  });
                  this.getTableData();
                  this.$emit("refresh");
                }
              });
            }
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      }
    },
    //全选
    handelAllClick() {
      for (let i = 0; i < this.tableData.length; i++) {
        this.tableData[i].isClick = true;
      }
    },
    //重置数据
    resetClick() {
      this.keyword = "";
      this.applyType = "";
      if (this.shopType == 0) {
        this.shopId = "";
      }
      this.getTableData();
    },
    //获取数据
    getTableData() {
      let params = {
        applyType: this.applyType,
        keyword: this.keyword,
      };
      if (this.shopType == 0) {
        params.shopId = this.shopId;
      } else {
        params.shopId = this.$store.state.shopId;
      }
      waitReceive(params).then((res) => {
        if (res.code == 0) {
          console.log("待接收", res);
          if (res.data.length != 0) {
            this.receiveShopId = res.data[0].receiveShopId;
            for (let i = 0; i < res.data.length; i++) {
              res.data[i].isClick = false;
            }
            this.tableData = res.data;
          } else{
            this.tableData = [];
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  min-height: 762px;
  margin-top: 12px;
  font-size: 14px;
  display: flex;
  flex-direction: column;

  .filter {
    height: 58px;
    display: flex;
    align-items: center;
    background: #fff;

    .sousuo {
      width: 153px;
      margin-right: 4px;
      margin-left: 16px;
    }

    .filterName {
      margin-left: 10px;
      margin-right: 4px;
    }

    .filterR {
      flex: 1;
      display: flex;
      justify-content: flex-end;
    }
  }

  .view {
    height: 694px;
    margin-top: 10px;
    overflow-y: scroll;

    .item {
      width: 301px;
      height: 100px;
      border-radius: 4px;
      display: flex;
      padding: 10px;
      font-size: 12px;
      color: #666;
      line-height: 17px;
      margin-bottom: 12px;
      float: left;
      margin-right: 12px;
      position: relative;

      .itemL {
        flex: 1;

        .itemName {
          margin-top: 4px;
          color: #333;
          margin-bottom: 8px;
        }

        .itemMsg {
          display: flex;
          align-items: center;
          margin-bottom: 8px;

          .shu {
            width: 1px;
            height: 14px;
            background: #666;
            margin: 0 8px;
          }
        }

        .epromNo {
          margin-bottom: 8px;
        }
      }

      .itemR {
        width: 150px;
        height: 100px;
        margin-left: 10px;
      }

      .dui {
        width: 24px;
        height: 24px;
        position: absolute;
        right: 8px;
        top: 8px;
        z-index: 3;
      }
    }
  }

  .view::-webkit-scrollbar {
    display: none;
  }
}
</style>
